import { pick } from "@constructor/services";
function createFragmentDataLake(versions, options) {
  const fragmentName = options.name;
  const dataLakeService = options.injector.__internal.inject("rootDataLakeService", {
    defaultValue: void 0
  });
  return {
    logEvent
  };
  function logEvent(eventOptions) {
    const expectedKeys = ["name", "data"];
    const fragmentOptions = pick(eventOptions, [...expectedKeys]);
    if (import.meta.env.DEV) {
      const unexpectedKeys = Object.keys(eventOptions).filter(
        (key) => !expectedKeys.includes(key)
      );
      if (unexpectedKeys.length) {
        console.warn(
          `Unexpected keys passed from fragment "${fragmentName}" to dataLake.logEvent(): ${unexpectedKeys.join()}. Please check your fragment code or extend keys whitelist in federation library.`
        );
      }
    }
    dataLakeService == null ? void 0 : dataLakeService.logEvent({
      ...fragmentOptions
      // TODO: complete
      // const fragmentVersion = versions.getVersion(options.name);
      // fragment_name: fragmentName,
      // fragment_version: fragmentVersion,
    });
  }
}
export {
  createFragmentDataLake as c
};
//# sourceMappingURL=dataLake.js.map
